import styled from "@emotion/styled"
import {
	PButton,
	PTable,
	PTableBody,
	PTableCell,
	PTableHead,
	PTableHeadCell,
	PTableHeadRow,
	PTableRow,
} from "@porsche-design-system/components-react"
import type { RoofColorOptionView } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage } from "react-intl"
import { formMessages } from "src/common/form.messages"
import { ButtonGroup, ExteriorColorTile, SmallIconOverlay } from "src/components"
import { selectCatalogRoofColorMessages } from "./selectCatalogRoofColor.messages"

export interface SelectCatalogRoofColorProps {
	isSubmitting: boolean
	onSubmit: () => Promise<void>
	roofColor: {
		options: RoofColorOptionView[]
		setValue: (roofColorOptionCode: string) => void
		value?: string
	}
	showCustomRoofColorContainer: () => void
}

export type SelectCatalogRoofColorSelectOption = RoofColorOptionView

export const SelectCatalogRoofColor = ({
	isSubmitting,
	onSubmit,
	roofColor,
	showCustomRoofColorContainer,
}: SelectCatalogRoofColorProps) => {
	return (
		<>
			<PTable caption="Select Catalog Roof Color List">
				<PTableHead>
					<PTableHeadRow>
						<PTableHeadCell>
							<FormattedMessage {...selectCatalogRoofColorMessages.name} />
						</PTableHeadCell>
						<PTableHeadCell>
							<FormattedMessage {...selectCatalogRoofColorMessages.code} />
						</PTableHeadCell>
					</PTableHeadRow>
				</PTableHead>
				<PTableBody>
					{roofColor.options.map((roofColorOption, index) => (
						<StyledPTableRow key={index} onClick={() => roofColor.setValue(roofColorOption.optionCode)}>
							<PTableCell>
								<SmallIconOverlay
									icon="check"
									visible={roofColor.value === roofColorOption.optionCode}
									backgroundHexCode={roofColorOption.hexCode}
								>
									<ExteriorColorTile
										color={roofColorOption.hexCode}
										label={roofColorOption.name}
										glossy={false}
									/>
								</SmallIconOverlay>
							</PTableCell>
							<PTableCell>{roofColorOption.optionCode}</PTableCell>
						</StyledPTableRow>
					))}
				</PTableBody>
			</PTable>

			<ButtonGroup>
				<PButton loading={isSubmitting} onClick={onSubmit}>
					<FormattedMessage {...formMessages.save} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={showCustomRoofColorContainer}>
					<FormattedMessage {...selectCatalogRoofColorMessages.customColor} />
				</PButton>
			</ButtonGroup>
		</>
	)
}

const StyledPTableRow = styled(PTableRow)`
	cursor: pointer;
`
